import { useCallback, useEffect, useState } from 'react';
import { fetchCompanyStaff } from '../../shared/booking/service-staff/serviceStaffRouting';
import { listServices } from '../../api/companyRecords';

export const useLocationAssignmentOverview = ({
  companyId,
  ownerId,
  enabled = true,
} = {}) => {
  const [staff, setStaff] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled && companyId));

  const refreshStaff = useCallback(async () => {
    if (!companyId) {
      setStaff([]);
      return;
    }

    try {
      const staffData = await fetchCompanyStaff({ companyId, ownerId });
      setStaff(staffData);
    } catch (error) {
      console.error('[useLocationAssignmentOverview] failed to load staff', error);
      setStaff([]);
    }
  }, [companyId, ownerId]);

  useEffect(() => {
    if (!enabled || !companyId) {
      setStaff([]);
      setServices([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    const load = async () => {
      try {
        const [servicesData] = await Promise.all([
          listServices({ companyId }),
          refreshStaff(),
        ]);
        if (!cancelled) {
          setServices(servicesData.filter((service) => !service._init));
          setLoading(false);
        }
      } catch (error) {
        console.error('[useLocationAssignmentOverview] failed to load services', error);
        if (!cancelled) {
          setServices([]);
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [companyId, ownerId, enabled, refreshStaff]);

  return { staff, services, loading };
};

export default useLocationAssignmentOverview;
